import React from "react";
import OptionType from "features/shared/components/selectInput/OptionType";
import SelectInput from "features/shared/components/selectInput/SelectInput";

interface Props {
  startDay?: number;
  endDay?: number;
  selectedDay?: number;
  name?: string;
  className?: string;
  emptyOptionLabel?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const DaySelect = ({
  startDay = 1,
  endDay = 31,
  selectedDay,
  name,
  className,
  emptyOptionLabel,
  onChange,
}: Props) => {
  const generateDays = (): OptionType[] => {
    let result: OptionType[] = [];

    if (emptyOptionLabel) {
      result.push({
        value: "",
        name: emptyOptionLabel,
      });
    }

    for (let i = startDay; i <= endDay; i++) {
      result.push({
        value: String(i),
        name: String(i),
      });
    }

    return result;
  };

  return (
    <div className={className}>
      <SelectInput
        name={name ?? "daySelect"}
        options={generateDays()}
        value={selectedDay ?? ""}
        onChange={onChange}
        className="mb-0"
      />
    </div>
  );
};

export default DaySelect;